export default __webpack_public_path__ + "images/81b2e2ada4ed86fd19d19bc16b3c8f39.svg";